import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, Maximize2, MessageCircleHeart } from "lucide-react";
import { ToothMascot } from "@/components/site/ToothMascot";
import { ChatPanel } from "./ChatPanel";
import { useSparkle } from "./useSparkle";

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const chat = useSparkle();
  useEffect(() => {
    const openIt = () => setOpen(true);
    window.addEventListener("tb:open-sparkle", openIt);
    return () => window.removeEventListener("tb:open-sparkle", openIt);
  }, []);
  return (
    <>
      <button onClick={() => setOpen(!open)} data-testid="ai-chat-widget-toggle" aria-label="Chat with Sparkle"
        className={`btn-pop fixed bottom-5 right-5 z-50 h-14 items-center gap-2 rounded-full bg-teal-600 pl-2 pr-5 text-white shadow-xl ring-4 ring-white hidden sm:flex`}>
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white"><ToothMascot className="h-8 w-8" /></span>
        <span className="hidden text-sm font-bold sm:inline">{open ? "Close" : "Ask Sparkle"}</span>
        {!open && <MessageCircleHeart className="h-4 w-4 sm:hidden" />}
      </button>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, y: 20, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20, scale: 0.95 }}
            data-testid="ai-chat-panel"
            className="fixed inset-0 z-[60] flex flex-col overflow-hidden bg-[#f0fdfa] sm:inset-auto sm:bottom-24 sm:right-4 sm:h-[78vh] sm:max-h-[720px] sm:w-[440px] sm:rounded-3xl sm:border-2 sm:border-teal-100 sm:shadow-2xl">
            <div className="flex items-center gap-3 bg-teal-600 px-4 py-3 text-white" style={{ paddingTop: "max(0.75rem, env(safe-area-inset-top))" }}>
              <ToothMascot className="h-11 w-11 rounded-full bg-white p-1" />
              <div className="flex-1"><p className="font-display text-lg font-semibold">Sparkle</p><p className="flex items-center gap-1.5 text-xs text-teal-100"><span className="h-2 w-2 rounded-full bg-lime-300" />Online · AI dental helper</p></div>
              <Link to="/ask" onClick={() => setOpen(false)} aria-label="Open full page" data-testid="ai-chat-expand" className="rounded-full p-2 hover:bg-white/15"><Maximize2 className="h-4 w-4" /></Link>
              <button onClick={() => setOpen(false)} data-testid="ai-chat-close-button" aria-label="Close chat" className="rounded-full p-2 hover:bg-white/15"><X className="h-5 w-5" /></button>
            </div>
            <ChatPanel chat={chat} compact />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
